import { styled, Button } from "@monolith-forensics/monolith-ui";
import { usePermissions } from "@/hooks/usePermissions";
import { useState } from "react";
import { useRef } from "react";

import {
  EvidenceTable,
  EvidenceTableHandle,
  EvidenceTableStateKeys,
  GetEvidenceQuery,
} from "@/Features";

enum View {
  ALL = "all",
  CASE = "case",
  MY = "my",
}

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
`;

const StyledPageHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const ViewButton = styled(Button)<{ $active: boolean }>`
  font-weight: 525;

  &,
  & > * {
    opacity: ${({ $active }) => ($active ? 1 : 0.85)} !important;
    text-decoration: none !important;
  }
`;

export const ContactEvidenceTabView: React.FC<{ contact_id: number }> = ({
  contact_id,
}) => {
  const { currentUser, hasPermission, MONOLITH_PERMISSIONS } = usePermissions();
  const [view, setView] = useState<View>(
    hasPermission(MONOLITH_PERMISSIONS.EVIDENCE_READ_ALL) ? View.ALL : View.CASE
  );
  const tableRef = useRef<EvidenceTableHandle>();
  const query: GetEvidenceQuery = {
    assigned_user_id: view === View.MY ? currentUser?.user_id : undefined,
    user_id: view === View.CASE ? currentUser?.user_id : undefined,
    contact_id,
  };

  const handleViewChange = (view: View) => {
    tableRef.current?.clearSelections?.();
    setView(view);
  };

  return (
    <StyledPage>
      <StyledPageHeader>
        {hasPermission(MONOLITH_PERMISSIONS.EVIDENCE_READ_ALL) && (
          <ViewButton
            variant={view === View.ALL ? "contained" : "outlined"}
            size="xxs"
            $active={view === View.ALL}
            onClick={() => handleViewChange(View.ALL)}
          >
            All
          </ViewButton>
        )}
        <ViewButton
          variant={view === View.CASE ? "contained" : "outlined"}
          size="xxs"
          $active={view === View.CASE}
          onClick={() => handleViewChange(View.CASE)}
        >
          My Cases
        </ViewButton>
        <ViewButton
          variant={view === View.MY ? "contained" : "outlined"}
          size="xxs"
          $active={view === View.MY}
          onClick={() => handleViewChange(View.MY)}
        >
          Assigned to Me
        </ViewButton>
      </StyledPageHeader>
      <EvidenceTable
        tableRef={tableRef}
        query={query}
        stateStoreKey={EvidenceTableStateKeys.CONTACT_EVIDENCE_TABLE}
      />
    </StyledPage>
  );
};
